enum EPayrollLogType {
  SEND = 'SEND',
  RETURN = 'RETURN',
}

export default EPayrollLogType;
